import axios from '@/http';
import api from '@/common/api.js';

let extimate = (btn, callback) => {
  const params = {
    buttonCodes: btn.join()
  }
  axios.post(api.getBtnAuth, params).then((res) => {
    if (res.errorCode == 0 && res.objectResult) {
      callback(res.objectResult)
    }
  })
}
const btn_extimate = (btn, callback) => {
  return extimate(btn, callback)
}

const BTN = {
  //工作台按钮权限
  // ######### 首页 ###########
  TEMP_TASK:'b08002',
  WORK_APPLY:'b08001',
  ENTRY_WORK:'b08003',
  // ######### 守护点 ###########
  SHD_ADD:'b50001',
  SHD_UPDATE:'b50002',
  SHD_DELETE:'b50003',
  SHD_CHANGE:'b50004',
  // ######### 组织架构 ###########
  ORG_ADD:"b20002",
  ORG_UPDATE:"b20001",
  ORG_USER:"b20003",
  // ######### 员工信息维护 ###########
  USER_ADD: 'b20106',
  USER_EXPORT: 'b20101',
  USER_U8IMPORT: 'b20102',
  USER_USERINFOIMPORT: 'b20103',
  USER_UPDATE: 'b20104',
  USER_QUIT: 'b20105',
  // ######### 消息管理 ###########
  MSG_ADD:'b40001',
  MSG_UPDATE:'b40004',
  MSG_DELETE:'b40002',
  MSG_PUBLISH:'b40003',
  // ######### 合同管理 ###########
  CONTRACT_ADD:'b60001',
  CONTRACT_UPDATE:'b60002',
  CONTRACT_DELETE:'b60003',
  // ######### 其他特殊项 ###########
  OTHER_ADD:'b70002',
  OTHER_IMPORT:'b70001',
  OTHER_UPDATE:'b70003',
  OTHER_DELETE:'b70004',
  //######### 系统管理 ###########
  //角色管理
  ROLE_ADD: "b100_000401_001",
  ROLE_UPDATE: "b100_000401_002",
  ROLE_DELETE: "b100_000401_003",
  //菜单管理
  MENU_FIRST_ADD: "b100_000403_003",
  MENU_SAME_ADD: "b100_000403_004",
  MENU_LOWER_ADD: "b100_000403_005",
  MENU_UPDATE: "b100_000403_001",
  MENU_DELETE: "b100_000403_002",
  //菜单按钮管理
  BUTTON_ADD: "b100_000404_001",
  BUTTON_UPDATE: "b100_000404_002",
  BUTTON_DELETE: "b100_000404_003",
  //配置项管理
  CONFIG_ADD: "b100_000405_001",
  CONFIG_UPDATE: "b100_000405_002",
  //调度任务管理
  TASK_ADD: "b100_000406_001",
  TASK_STOP: "b100_000406_002",
  TASK_RESTART: "b100_000406_003",
  TASK_TRIGGER: "b100_000406_004",
  TASK_UPDATE: "b100_000406_005",
  TASK_DELETE: "b100_000406_006",
  TASK_RECOVER: "b100_000406_007",
  //缓存管理
  CACHE_DIST: "b100_000407_001",
  CACHE_CONF: "b100_000407_002",
  //数据字典管理
  DIST_EXPORT: "b100_000408_001",
  DIST_ADD: "b100_000408_002",
  DIST_UPDATE: "b100_000408_003",
  DIST_BATCH_DELETE: "b100_000408_004",
}

export {
  btn_extimate,
  BTN
}



// WEBPACK FOOTER //
// ./src/utils/btnAuth.js